import React from 'react';
import GlobalSearch from './GlobalSearch';
import ReactDOM from 'react-dom';
import './commonSearch.css';

const renderApp = () => ReactDOM.render(
    <GlobalSearch CenterSearch={true} />,
    document.getElementById('react-app')
);

const renderApp1 = () => ReactDOM.render(
    <GlobalSearch />,
    document.getElementById('react-app-menu')
);

renderApp();
renderApp1();